import { User } from "../../lib/appManagers/appUsersManager";
import getPeerId from "../../lib/appManagers/utils/peers/getPeerId";
import rootScope from "../../lib/rootScope";
import { Rsp } from "../model/rsp";
import AwsUploader, { CDN_PREFIX, CND_INDEX_DIR, CND_TOS_DIR } from "../utils/AwsUploader";
import { CacheTypes, getCache, putCache } from "../utils/cacheUtil";
import { sendText } from "../utils/messageUtil";
import request from "../utils/request";
import CryptoJS from 'crypto-js';
import { AppManagers } from "../../lib/appManagers/managers";

export async function reportFans(user: User) {
  // const incomeFansType = CacheTypes.INCOME_FANS;
  // const incomeFansKey = `${user.id}`;

  // const reported = await fansReported(incomeFansKey);

  // if (reported == true) {
  //   console.log(`Tolink report fans ignore with user: ${user.id}, already reported!!!`);
  //   return;
  // } else {
  //   console.log(`Tolink report fans with user: ${user.id}`);
  // }

  // const incomeFansItem: IncomeFansItem = await createIncomFansItem(user);

  // incomeFans(incomeFansItem).then((rsp) => {
  //   console.log(`Tolink income fans with rsp ${rsp.code}`);
  //   if (rsp.code == 200) {
  //     putCache(incomeFansKey, incomeFansType, new Date().getTime());
  //   }
  // });
}

export async function batchReportFans() {
  console.log(`Tolink batchReportFans...`);
  // rootScope.managers.appUsersManager.getUsers().then(async (users) => {
  //   console.log(`Tolink batchReportFans with users: `, users);

  //   let fansList: IncomeFansItem[] = [];

  //   for (let id in users) {
  //     const user = users[id];

  //     const reported = await fansReported(id);

  //     if (reported) continue;

  //     const peerId: number = parseInt(id);
  //     if (peerId == rootScope.myId) continue;

  //     const incomeFansItem: IncomeFansItem = await createIncomFansItem(user);

  //     fansList.push(incomeFansItem);

  //     if (fansList.length == 100) {
  //       await reportFansList(fansList);
  //       fansList = [];
  //     }
  //   }

  //   if (fansList.length > 0) {
  //     await reportFansList(fansList);
  //   }
  // });
}

async function reportFansList(fansList: IncomeFansItem[]) {
  console.log(`Tolink reportFansList with fansList: `, fansList);
  if (fansList.length <= 0) return;

  const rsp = await batchIncomeFans(fansList);

  if (rsp.code == 200) {
    for (let item of fansList) {
      await putCache(`${item.sysId}`, CacheTypes.INCOME_FANS, new Date().getTime());
    }
  }
}

async function getBlobMD5(blob: Blob): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      if (event.target) {
        const arrayBuffer = event.target.result as ArrayBuffer;
        const wordArray = CryptoJS.lib.WordArray.create(arrayBuffer);
        const md5Hash = CryptoJS.MD5(wordArray).toString(CryptoJS.enc.Hex);
        resolve(md5Hash);
      } else {
        reject(new Error('Error reading Blob content'));
      }
    };

    reader.onerror = (event) => {
      reject(reader.error);
    };

    reader.readAsArrayBuffer(blob);
  });
}

export async function uploadAvatarToAws(peerId: number) {
  // const peerPhoto = await rootScope.managers.appPeersManager.getPeerPhoto(peerId);

  // if (peerPhoto) {
  //   const url = await rootScope.managers.appAvatarsManager.loadAvatar(peerId, peerPhoto, 'photo_small');

  //   const response = await fetch(url);
  //   const blob = await response.blob();
  //   const blobMd5 = await getBlobMD5(blob);

  //   console.log('Tolink upload avatar to aws with blobMd5: ', blobMd5);

  //   const file = new File([blob], `tolink-avatar-${peerId}`, { type: blob.type });
  //   const fileName = `${peerId}-${blobMd5}`;

  //   const avatarAwsRsp = await fetch(`${CDN_PREFIX}${CND_INDEX_DIR}${CND_TOS_DIR}/${fileName}`, { method: 'HEAD' });

  //   if (avatarAwsRsp && avatarAwsRsp.ok) {
  //     return avatarAwsRsp.url;
  //   }

  //   const uploadRsp = await AwsUploader.getIns().upload(file, `${CND_INDEX_DIR}${CND_TOS_DIR}/${fileName}`, blob.type).catch((e) => { });

  //   if (uploadRsp) {
  //     return uploadRsp;
  //   }
  //   return '';
  // }
}

function incomeFans(data: IncomeFansItem): Promise<Rsp<any>> {
  // return request({
  //   url: "/fans/income-fans",
  //   method: "post",
  //   data,
  // });
}

function batchIncomeFans(data: IncomeFansItem[]): Promise<Rsp<any>> {
  return request({
    url: "/fans/batch-sync",
    method: "post",
    data: {
      list: data
    },
  });
}

async function fansReported(fansId: string) {
  const reportTime: number = await getCache(fansId, CacheTypes.INCOME_FANS);
  if (!reportTime) return false;

  const now: number = new Date().getTime();
  return (now - reportTime < 10 * 60 * 60 * 1000);
}

async function createIncomFansItem(user: User): Promise<IncomeFansItem> {
  const peerId: number = parseInt(`${user.id}`);
  const historyResult = await rootScope.managers.appMessagesManager.getHistory({ peerId: peerId, limit: 1000 });

  let fansTime: number = 0;
  let fromMe: boolean = false;
  if (historyResult.history && historyResult.history.length > 0) {
    const firstMsg = await rootScope.managers.appMessagesManager.getMessageById(historyResult.history[historyResult.history.length - 1]);
    fansTime = firstMsg.date * 1000;
    fromMe = (firstMsg.fromId == rootScope.myId);
  }

  const sysAvatar = await uploadAvatarToAws(peerId);
  return {
    sysType: 1,
    sysId: `${user.id}`,
    sysAccount: user.username,
    sysNick: user.sortName,
    sysAvatar: sysAvatar,
    sysPhone: user.phone,
    sysCountry: user.lang_code,
    fansTime: fansTime,
    invalidType: (fromMe || fansTime == 0) ? 2 : 0
  };
}

const WORDS = [
  "Baby, do you know? I've prepared the most tempting secrets for you in front of the camera, just one click from you, come and unlock them 🔥🥵.",
  "My heart is pounding wildly, only for you to unlock all my secrets, don't make me wait too long, click the link, let me show you everything.",
  "Are you ready? I'm already wet waiting for you to explore, click this link, let me show you my most irresistible side 🔥.",
  "Baby, just one tap of your finger, and you can see all my secrets, don't make me wait too long, I'm waiting for you to unlock my deepest parts.",
  "My body is craving you, be brave, click the link, let me welcome your arrival in the most alluring way 🔥🥵.",
  "Only for you, I've become even more charming in front of the camera, quickly click this link, let me conquer you with all my allure.",
  "Baby, my secrets are here waiting for you to unlock, if you don't move your finger, I can't help but sweat 🔥.",
  "Do you know? I've prepared the most alluring scenes for you, all you need is a little courage, click the link, and I'll show you everything wholeheartedly.",
  "My body is telling you—come and unlock my most private secrets 🔥, I'm here, waiting for you to conquer.",
  "Baby, all of me is ready for you, just one step away, click the link, let me make you irresistible with my sexiest."
]

export async function sendPayLink(userId: UserId, manual: boolean = false) {
  // var hasSendUids = localStorage.getItem('tolink_paylink_send_uids');

  // const isNSFWEnable = window.isNSFWEnable();
  // if(!manual) {
  //   if(!isNSFWEnable) {
  //     return;
  //   }
  //   const hasSend = hasSendUids && hasSendUids.split(',').includes(`${userId}`)
  //   if(hasSend) {
  //     console.log(`Tolink sendPayLink ignore with user: ${userId}, already sent!!!`);
  //     return;
  //   }
  // }
  

  // const mySelf = await rootScope.managers.appUsersManager.getSelf()

  // const config = localStorage.getItem('tg_of_config');

  // if (config) {
  //   const configObj = JSON.parse(config);
  //   sendText(getPeerId(userId), `${configObj.desc}.\n ${configObj.link}?mid=${mySelf.id}&tid=${userId}`);
  // } else {

  //   // 随机生成一个索引
  //   const randomIndex = Math.floor(Math.random() * WORDS.length);

  //   // 从数组中取出随机选中的字符串
  //   const randomMessage = WORDS[randomIndex];

  //   const resp = await fetch('https://s.ak7.co/api/create', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify({
  //       'longUrl': `${import.meta.env.VITE_NSFW_URL}?mid=${mySelf.id}&tid=${userId}`
  //     })
  //   })

  //   const json = await resp.json();

  //   sendText(getPeerId(userId), `${randomMessage}.\n ${json.shortLink}`);
  // }
  // hasSendUids = hasSendUids ? `${hasSendUids},${userId}` : `${userId}`
  // localStorage.setItem('tolink_paylink_send_uids', hasSendUids)
}


export function isUserFirstTimeChat(peerId: any, managers: AppManagers): boolean {
  // try {
  //   // 1. 获取对话信息
  //   const dialog = managers.appMessagesManager.getDialogOnly(peerId);

  //   // 2. 如果没有对话记录，说明是第一次
  //   if (!dialog) {
  //     return true;
  //   }

  //   // 3. 检查对话是否有历史消息
  //   const hasHistory = (dialog as any).top_message > 0;
  //   if (!hasHistory) {
  //     return true;
  //   }

  //   // 4. 检查消息存储
  //   const messagesStorage = managers.appMessagesManager.getHistoryMessagesStorage(peerId);
  //   const hasStoredMessages = (messagesStorage as any).size > 0;

  //   // 5. 检查历史存储
  //   const historyStorage = managers.appMessagesManager.getHistoryStorage(peerId);
  //   const hasHistoryCount = (historyStorage as any).count > 0;

  //   // 如果没有存储的消息且没有历史计数，认为是第一次聊天
  //   return !hasStoredMessages && !hasHistoryCount;

  // } catch (error) {
  //   console.error('检查第一次聊天时出错:', error);
  //   return false; // 出错时保守处理，认为不是第一次
  // }
  return false;
}

/**
 * 处理第一次聊天的用户，包括检查和执行相关逻辑
 */
export async function handleFirstTimeChatUser(peerId: any, managers: AppManagers, trigger: 'new_dialog' | 'new_message' = 'new_dialog') {
  console.log('第一次！！！')
  // // 仅处理用户，不处理群组
  // if (!peerId.isUser()) {
  //   return false;
  // }

  // // 不处理自己
  // if (peerId === rootScope.myId) {
  //   return false;
  // }

  // const isFirstChat = isUserFirstTimeChat(peerId, managers);

  // if (isFirstChat) {
  //   console.log(`🎉 用户${peerId}第一次与你聊天 (触发器: ${trigger})`);

  //   try {
  //     const user = await managers.appUsersManager.getUser(peerId);

  //     // 忽略机器人
  //     if (user.pFlags.bot) {
  //       return false;
  //     }

  //     // 在这里可以添加第一次聊天的特殊处理逻辑
  //     // 例如：
  //     // 1. 发送欢迎消息
  //     // 2. 记录新用户统计
  //     // 3. 触发特殊的营销活动
  //     // 4. 自动标记用户

  //     console.log(`第一次聊天用户信息:`, {
  //       id: user.id,
  //       username: user.username,
  //       firstName: user.first_name,
  //       lastName: user.last_name,
  //       phone: user.phone
  //     });

  //     // 这里可以调用其他业务逻辑
  //     // await sendWelcomeMessage(peerId);
  //     // await trackNewUser(user);

  //     return true;
  //   } catch (error) {
  //     console.error('处理第一次聊天用户时出错:', error);
  //   }
  // }

  return false;
}

interface IncomeFansItem {
  sysType: number
  sysId: string
  sysAccount: string
  sysNick: string
  sysAvatar: string
  sysPhone: string
  sysCountry: string
  fansTime: number
  invalidType: number
}